/**
 * 按日期查询拍卖场次
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 确认收款
// 接口地址   api/v1/auctions/auction_order_complete/{order_id}
Mock.mock(/\/auctions\/auction_order_complete\/\d+/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'actual_paid_amount': '', // 实收金额，单位： 分
    'paid_date': '',
    'paid_note': '',
    'receipt_images': ''
  }
})
